import { SegmentedControl } from '@teach/ui'
import type { CourseWithoutBlocks } from '@/types/course'
import type { ContentLang } from '../../editorSlice'
import { LANG_LABEL } from '../../lib/contentLangLabels'
import { isLangSlotComplete } from '../../lib/langCompleteness'
import { hasTranslationRow } from '../../lib/courseTranslation'
import { useHasStartedTranslationRun } from '../studio/useBlocksInRun'

interface Props {
  course: CourseWithoutBlocks
  /**
   * ЧЕРНОВИК формы. Точка считается по нему, а не по серверному `course`: поля
   * сохраняются на blur, и точка, читающая ответ сервера, гасла бы не в момент
   * ввода, а через PUT плюс рефетч всего курса. Признак «есть строка перевода»
   * при этом остаётся на `course` — заводит её прогон, а не набранный текст.
   */
  draft: CourseWithoutBlocks
  value: ContentLang
  onChange: (lang: ContentLang) => void
}

const LANGS: ContentLang[] = ['ru', 'en']

/**
 * Переключатель языка полей названия и описания во вкладке «Основное». Язык
 * МЕСТНЫЙ (держит `CourseSettingsContent`): язык правки редактора — шапка,
 * холст, инструменты — от него не меняется (решение заказчика).
 * Показывается только у курса со строкой перевода
 * (`hasTranslationRow`) — до первого перевода второго слота у курса нет и
 * переключать нечего. Смену базового языка этот признак больше не лочит (§6.10).
 */
export const SettingsLangSwitcher = ({ course, draft, value, onChange }: Props) => {
  const hasStartedRun = useHasStartedTranslationRun(course.id)

  if (!hasTranslationRow(course, hasStartedRun)) return null

  return (
    <SegmentedControl
      size="sm"
      value={value}
      onChange={onChange}
      options={LANGS.map((id) => ({
        id,
        label: LANG_LABEL[id],
        dot: !isLangSlotComplete(id, draft),
        dotTestId: 'lang-incomplete-dot',
      }))}
    />
  )
}
